'use strict';

import React from 'react'

class PanelClaro extends React.Component {

  constructor() {
    super();
  }

  render() {
    return <section id={this.props.sectionName} className="section-1 section-micuentavtc container mi-cuenta ficha">
      <div className="padding-1">
        <div className="panel-light padding-2">
          {this.props.children}
        </div>
      </div>
    </section>

  }
}

export default PanelClaro;